(async () => {
    const { Core } = await importModule('Core');
    customElements.define('product-options-dropdown', class extends Core {
        elements = { dropdown: 'drop-down', current: '[data-current]' }

        render() {
            this.syncNativeOptions();
            if (!this._boundChange) {
                this._boundChange = this._onChange.bind(this);
                this.addEventListener('change', this._boundChange);
            }
            if (!this._pickerBound && this.$dropdown) {
                this._pickerBound = true;
                const toggle = this.querySelector('[data-toggle]');
                const updateExpanded = () => toggle?.setAttribute('aria-expanded', String(this.$dropdown.open));
                this.$dropdown.addEventListener('dropdown:open', updateExpanded);
                this.$dropdown.addEventListener('dropdown:close', updateExpanded);
                this.addEventListener('pointerdown', () => { this._arrowSelection = false; });
                this.addEventListener('click', event => {
                    const label = event.target.closest('label');
                    if (!label || !this.contains(label) || event.target.matches('input')) return;
                    const radio = label.querySelector('input[type="radio"]');
                    if (!radio || radio.disabled) return;
                    event.preventDefault();
                    radio.click();
                });
                this.addEventListener('keydown', event => {
                    if (event.key === 'Tab') {
                        requestAnimationFrame(() => {
                            if (!this.contains(document.activeElement)) {
                                this._arrowSelection = false;
                                this.$dropdown.close();
                            }
                        });
                    }
                    if (event.key === 'Escape' && this.$dropdown.open) {
                        event.preventDefault();
                        this._arrowSelection = false;
                        this.$dropdown.close();
                        toggle?.focus({ preventScroll: true });
                    } else if (event.target === toggle && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
                        event.preventDefault();
                        this._arrowSelection = true;
                        this.$dropdown.open = true;
                        const radios = this.availableRadios();
                        (radios.find(radio => radio.checked) || radios[0])?.focus({ preventScroll: true });
                    } else if (event.target.matches('input[type="radio"]') && event.key.startsWith('Arrow')) {
                        event.preventDefault();
                        const radios = this.availableRadios();
                        const direction = ['ArrowUp', 'ArrowLeft'].includes(event.key) ? -1 : 1;
                        const next = radios[(radios.indexOf(event.target) + direction + radios.length) % radios.length];
                        this._arrowSelection = true;
                        next?.focus({ preventScroll: true });
                        next?.click();
                    } else if (event.target.matches('input[type="radio"]') && [' ', 'Enter'].includes(event.key)) {
                        this._arrowSelection = false;
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            event.target.click();
                            this.$dropdown.close();
                            toggle?.focus({ preventScroll: true });
                        }
                    }
                });
            }
        }

        availableRadios() {
            return Array.from(this.querySelectorAll('input[type="radio"]')).filter(radio => {
                const row = radio.closest('label') || radio;
                const menu = row.closest('[data-menu]');
                const measurable = !menu || menu.offsetParent !== null;
                if (measurable && row.offsetParent === null) return false;
                return !radio.disabled && !row.hidden && getComputedStyle(row).display !== 'none' && row.getAttribute('aria-hidden') !== 'true';
            });
        }

        syncNativeOptions() {
            const select = this.querySelector('select');
            if (!select) return;
            const radios = this.availableRadios();
            const currentValue = this.$current?.textContent.trim();
            const unavailableCurrent = currentValue && !radios.some(radio => radio.value === currentValue);
            const options = Array.from(select.options).filter(option => !option.dataset.unavailableCurrent);
            if (options.length !== radios.length || options.some((option, i) => option.value !== radios[i].value)) {
                select.replaceChildren(...radios.map(radio => new Option(radio.value, radio.value, radio.checked, radio.checked)));
            }
            const selected = radios.find(radio => radio.checked);
            if (unavailableCurrent) {
                let placeholder = select.querySelector('[data-unavailable-current]');
                if (!placeholder || placeholder.textContent !== currentValue) {
                    placeholder?.remove();
                    placeholder = new Option(currentValue, '', true, true);
                    placeholder.disabled = true;
                    placeholder.dataset.unavailableCurrent = 'true';
                    select.prepend(placeholder);
                }
                select.selectedIndex = 0;
            } else {
                select.querySelector('[data-unavailable-current]')?.remove();
                select.value = selected ? selected.value : '';
            }
            this.querySelector('[data-toggle]')?.setAttribute('aria-label', `${select.getAttribute('aria-label')}: ${unavailableCurrent ? currentValue : (selected?.value || currentValue || '')}`);
        }

        _onChange(event) {
            const { target } = event;
            if (target.tagName === 'SELECT') {
                event.stopPropagation();
                const radio = this.availableRadios().find(input => input.value === target.value);
                if (radio) radio.click();
                else this.syncNativeOptions();
                return;
            }
            if (!target.matches('input[type="radio"]')) return;
            this.$current.textContent = target.value;
            this.syncNativeOptions();
            if (!this._arrowSelection) {
                const keyboardRadio = document.activeElement === target;
                this.$dropdown.close();
                if (keyboardRadio) this.querySelector('[data-toggle]')?.focus({ preventScroll: true });
            }
        }
    });
})();





